export default __webpack_public_path__ + "static/media/line-seq-swap-arrow-up-gray.18b93ee4.svg";